import React, { FC } from 'react';

import { EvSvgIcon, Info } from '@evinced-private/ui-common';

import './InfoLine.scss';

interface IInfoLine {
	msg: string;
}

const InfoLine: FC<IInfoLine> = ({ msg }) => (
	<div className="info-line-msg">
		<span className="info-line-icon">
			<EvSvgIcon icon={Info} isSmall />
		</span>
		<p className="info-line-text">{msg}</p>
	</div>
);

export { InfoLine };
